import React, { useCallback, useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { Dotsmenu } from '@e3dc-react/icons'
import useInstallationInvitation from 'src/Libs/installation-rights-management/hooks/use-installation-invitation'
import { useAccessInvitationDialog } from 'src/Libs/installation-rights-management/hooks'

interface Props {
  item: InstallationInvitationModel
  onChange: () => void
  onResendInvite?: (invitation: InstallationInvitationModel) => void
}

const ActionMenu: React.FC<Props> = ({ item, onChange, onResendInvite }) => {
  const { t } = useCustomTranslation()
  const { removeInvitation } = useInstallationInvitation()
  const { resend } = useAccessInvitationDialog(item)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const closeMenu = (): void => {
    setAnchorEl(null)
  }

  const handleResendInvite = useCallback(() => {
    if (onResendInvite) {
      resend().then(() => {
        onResendInvite(item)
      })
    }
    closeMenu()
  }, [onResendInvite, resend, item])

  const handleClose = useCallback((): void => {
    closeMenu()
  }, [])

  const handleRemoveDialog = useCallback(
    (_: React.MouseEvent<HTMLElement>): void => {
      if (item.token) {
        removeInvitation(item.token, undefined, undefined, !item.expiredAt).then(() => onChange())
      } else {
        console.error('Invalid token found', item.token)
      }
      closeMenu()
    },
    [item.token, onChange, removeInvitation, item.expiredAt]
  )

  return (
    <div>
      <IconButton onClick={handleClick} sx={theme => ({ color: open ? theme.palette.primary.main : theme.palette.grey.grey00 })}>
        <Dotsmenu />
      </IconButton>
      <Menu id="action-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleRemoveDialog}>{t('common.remove')}</MenuItem>
        {onResendInvite && <MenuItem onClick={handleResendInvite}>{t('installation.access-and-invitations.table.columns.resend-invite')}</MenuItem>}
      </Menu>
    </div>
  )
}

export default ActionMenu
